// these events should match https://github.com/alltrails/alltrails_analytics_definition/blob/main/analytics.json
export const CREATE_MAP_NAV_BUTTON_TAPPED = 'create map nav button tapped';
export const FAVORITES_NAV_BUTTON_TAPPED = 'favorites nav button tapped';
export const GLOBAL_NAV_SIGNUP_BUTTON_TAPPED = 'global nav signup button tapped';
export const HOMEPAGE_SIGNUP_BUTTON_TAPPED = 'homepage signup button tapped';
export const LISTS_NAV_BUTTON_TAPPED = 'lists nav button tapped';
export const LOG_IN_PAGE_SIGNUP_BUTTON_TAPPED = 'log in page signup button tapped';
export const MAPS_NAV_BUTTON_TAPPED = 'maps nav button tapped';
export const ONE_TAP_DISPLAYED = 'one tap displayed';
export const PRINT_FAILED = 'print failed';
export const PRINT_STARTED = 'print started';
export const PRINT_SUCCEEDED = 'print succeeded';
export const SEARCH_RESULT_SELECTED = 'search result selected';
export const SIGN_UP_PAGE_VIEWED = 'sign up page viewed';
export const SIGN_UP_SUCCEEDED = 'sign up succeeded';
export const STATIC_MAP_TAPPED = 'static map tapped';
export const TRAIL_CARD_ADD_TO_LIST_BUTTON_TAPPED = 'trail card add to list button tapped';
export const TRAIL_DETAILS_ADD_TO_LIST_BUTTON_TAPPED = 'trail details add to list button tapped';
export const TRAIL_DETAILS_GPX_DOWNLOAD_BUTTON_TAPPED = 'trail details gpx download button tapped';
export const TRAIL_DETAILS_PRINT_BUTTON_TAPPED = 'trail details print button tapped';
export const TRAIL_DETAILS_SHARE_BUTTON_TAPPED = 'trail details share button tapped';
export const TRAIL_PAGE_VIEW_LIMIT_REACHED = 'trail page view limit reached';
